<template>
  <div>
    <PageTitle
      title="Incomes"
      :btnCreate="true"
      :createRoute="'/purchase/add'"
      :createPopup="true"
      :permission="'Category Create'"
      @onClickCreate="OpenModal()"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-flex>
        <v-row>
          <!-- Income from warehouse -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pr-1 pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="
                background-image: linear-gradient(to right, #432371, #faae7b);
              "
              v-if="ProductCategory.length > 0"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>
                      Warehouse ({{
                        IncomeForWarehouse[0] ? IncomeForWarehouse[0] : '0'
                      }})
                    </div>
                  </div>
                </v-col>
                <v-col cols="6" class="text-right font-weight-bold">
                  <div class="topCard mr-3">
                    {{
                      IncomeForWarehouse[1]
                        ? IncomeForWarehouse[1]
                        : '0' | formatCurrency
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- income from shop -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pr-1 pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="
                background-image: linear-gradient(to right, #9bafd9, #103783);
              "
              v-if="ProductCategory.length > 0"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>
                      Shop ({{ IncomeForShop[0] ? IncomeForShop[0] : '0' }})
                    </div>
                  </div>
                </v-col>
                <v-col cols="6" class="text-right font-weight-bold">
                  <div class="topCard mr-3">
                    {{
                      IncomeForShop[1] ? IncomeForShop[1] : '0' | formatCurrency
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- total payments component -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pr-1 pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="
                background-image: linear-gradient(to right, #0061ff, #60efff);
              "
              v-if="ProductCategory.length > 0"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>Total Income</div>
                  </div>
                </v-col>
                <v-col cols="6" class="text-right font-weight-bold">
                  <div class="topCard mr-3">
                    {{ total | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter-outline' : 'mdi-filter' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="!show">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="['search', 'incomeCategory', 'incomeFor', 'dateRange']"
              v-model="filter"
              :columns="columns"
              :msgs="'Reference Number'"
            ></TableFilters>
          </v-row>
        </v-card>
      </v-expand-transition>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <v-col
          class="pr-1 text-right"
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          xl="2"
        >
          <CategoryForm
            ref="createcategory"
            :Income="Incomes"
            :visible="isCategoryFormVisible"
            @close="AddCategory($event)"
            @afterSave="refreshData()"
          />
        </v-col>
        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="ProductCategory"
          class="row-pointer"
          item-key="id"
          hide-default-footer
          style="font-family: 'Source Sans Pro', sans-serif"
        >
          <template v-slot:no-data>
            <noData
              class="mt-10 container justify-center item-center"
              name="shop"
            />
          </template>
          <!-- No -->
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>
          <template v-slot:item.amount="{ item }" :slot-scope="props">
            {{ item.amount | formatCurrency }}
          </template>
          <template v-slot:item.date="{ item }" :slot-scope="props">
            {{ item.date | formatDate }}
          </template>

          <!-- <template v-slot:item.income_for="{ item }" :slot-scope="props">
            {{ item.income_for ? item.income_for : "--------" }}
          </template> -->

          <template v-slot:item.shoporwarehouse="{ item }">
            <div v-if="item.income_for == 'Warehouse'">
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="grey lighten-1"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter="warehouseNameFind(item)"
                    >mdi-information</v-icon
                  >
                </template>
                <span>{{ warehouseName }}</span>
              </v-tooltip>
              {{
                WarehouseView == 'name'
                  ? item.warehouse.sortform
                  : item.warehouse.name
              }}
            </div>
            <div v-else>
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="grey lighten-1"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter="shopNameFind(item)"
                    >mdi-information</v-icon
                  >
                </template>
                <span>{{ shopName }}</span>
              </v-tooltip>
              {{ ShopView == 'name' ? item.shop.sortform : item.shop.name }}
            </div>
          </template>

          <!-- Status -->

          <!-- <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="px-5">
              <template>
                <AuditLogs :Type="'incomes'" :Typeid="item.id" />
              </template>
            </td>
          </template> -->

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="category"
              :item="item"
              @refreshList="refreshData"
              editPermission="Category Edit"
              @onEditClicked="EditModal(item)"
              :isEditModal="true"
              :isSubViewModal="true"
              @onSubViewClicked="ViewCategory(item)"
            ></list-menu>
          </template>

          <template v-slot:footer>
            <pagination
              url="incomes"
              @getPageNumber="setPagenumber"
              :filterAction="true"
              @paginationOptions="setPaginationOptions"
              @response="receiveCategoryData"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>

        <!-- <v-row>
        <v-col cols="12 pa-5" align-self="end">
          <v-container class="max-width"></v-container>
        </v-col>
      </v-row> -->
        <!-- {{existImage}} -->
        <EditCategoryForm
          :visible="EditScheduleForm"
          ref="editcategory"
          :Income="Incomes"
          @afterSave="refreshData()"
          @close="EditCategory($event)"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TableFilters from '@/components/base/TableFilters';
import CategoryForm from './IncomeCreate';
import { required, email, max } from 'vee-validate/dist/rules';
import pagination from '../../shared/components/pagination';

import FileUpload from '@/components/base/FileUpload';
import EditCategoryForm from './IncomeEdit';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { Incomes } from '@/models/Incomes';
import * as moment from 'moment/moment';
import noData from '../../../components/shared/noItem';
extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  data: () => ({
    show: 'false',
    warehouseName: '',
    shopName: '',
    isLoading: false,
    paginationOptions: {},
    // expanded: [],
    // singleExpand: false,
    isCategoryFormVisible: false,
    EditScheduleForm: false,
    Incomes: new Incomes(),
    pagination1: {
      descending: true,
      page: 1,
      total: 0,
      rowsPerPage: 2,
      sortBy: 'fat',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
      },
      // {
      //   text: "Income For",
      //   value: "income_for",
      //   show: true,
      //   disabled: false,
      // },

      {
        text: 'Shop / Warehouse',
        value: 'shoporwarehouse',
        show: true,
        disabled: false,
      },
      {
        text: 'Income Category',
        value: 'category.name',
        show: true,
        disabled: false,
      },
      {
        text: 'Note',
        value: 'remark',
        show: true,
        disabled: false,
      },
      {
        text: 'Amount',
        value: 'amount',
        show: true,
        disabled: false,
        align: 'right',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    ProductCategory: [],
    IncomeForShop: [],
    IncomeForWarehouse: [],
    // newbrand: { name: "", id: "", is_active: "" },
    filter: {
      name: '',
      search: '',
      status: '',
    },
  }),
  computed: {
    ...mapState(['ShopView']),
    ...mapState(['WarehouseView']),
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    CategoryForm,
    pagination,
    EditCategoryForm,
    FileUpload,
    TableFilters,
    noData,
  },

  methods: {
    warehouseNameFind(item) {
      this.warehouseName = item.warehouse.name;
    },
    shopNameFind(item) {
      this.shopName = item.shop.name;
    },
    ViewCategory(item) {
      this.$router.push(`/masterdata/category/${item.id}`);
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    navigate(item) {},

    OpenModal() {
      this.isCategoryFormVisible = true;
      this.Incomes = new Incomes();
    },

    // income From Shop
    incomeForShop(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'Shop') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let incomeForShopArray = [value, amount];
      return incomeForShopArray;
    },

    // income From Warehouse
    incomeForWarehouse(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'Warehouse') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let incomeForWarehouseArray = [value, amount];
      return incomeForWarehouseArray;
    },
    receiveCategoryData(data) {
      this.ProductCategory = data;
      this.total = this.sumField(this.ProductCategory, 'amount');
      this.IncomeForShop = this.incomeForShop(
        this.ProductCategory,
        'income_for',
        'amount',
      );
      this.IncomeForWarehouse = this.incomeForWarehouse(
        this.ProductCategory,
        'income_for',
        'amount',
      );
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    AddCategory($event) {
      this.isCategoryFormVisible = false;
    },
    EditModal(data) {
      this.EditScheduleForm = true;

      this.GetIncomeBySingle(data.id);
    },
    EditCategory($event) {
      this.EditScheduleForm = false;
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += element[filed];
      });
      return value;
    },
    GetIncomeBySingle(id) {
      this.$store
        .dispatch(`warehouse/GetIncomes`, id)
        .then((res) => {
          this.Incomes = res.data;
          this.Incomes.date = moment(res.data.date).format('YYYY-MM-DD');

          //this.existImage = res.data.image;
          // this.refreshData();

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
  },
  created() {
    //this.refreshData();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.topCard {
  color: white;
}
.min-button::before {
  display: none;
}
</style>
